import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {loadConclusions, logout, clearRedirect } from "./../../actions/actions";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Pager from './../controls/Pager';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Header from './../Header';
import Footer from './../Footer';
import { DatePicker } from 'material-ui-pickers';
import { Link, Redirect } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Grid from '@material-ui/core/Grid';
import { roles } from './../../helpers/trans';
import OldBrowserMessage from './../OldBrowserMessage';

const styles = theme => ({
    root: {
        width: '100%'
    },
    contentWrapper: {
        marginLeft: '3em',
        marginRight: '3em'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },

    resetPadding: {
        padding: 0,
    },
    newColor: {
        borderRadius: 0,
        backgroundColor: 'transparent',
        borderBottom: '1px solid #76b5b8',
        boxShadow: 'none',
        '&::before': {
            height: 0
        },
    },
    color:{
        color:'#76b5b8'
    },
    title:{
        color:'#76b5b8',
        textOverflow: 'ellipsis',
        maxWidth: '95%'
    },
    headerStatic:{
        margin: '60px 0',
        fontSize: 26,
        fontFamily:'PT Sans Narrow, sans-serif',
        fontWeight: 'bold'
    },
    textStatic:{
        margin: '60px 0',
        maxWidth: '65%',
        color: '#5b5b5b'
    },
    blockDescription:{
        marginTop: '30px',
        marginBottom: '20px'
    }
});


export class ObjectsInspector extends React.Component{
    constructor(props) {
        super(props);
        this.searchCo = React.createRef();
        this.state = {
            user:{},
            auth:false,
            search: {
                name: '',
                region: '',
                designer: '',
                expertize_number:'',
                reg_number:'',
                customer:'',
                realization_date_from: null,
                realization_date_to: null

            },
            co: []
        };
    }
    logout = () => {
        this.props.logout();
        this.setState({auth:false, user:{}, redirect:null});
    }

    updateDateInput = name => date => {
        console.log(date);
        console.log(name);
        let value = date.format().split('T')[0];
        //let value = date.toISOString().split('T')[0];
        let data = {[name]: value } ;
        let currentData = this.state.search;
        this.setState({search:{ ...currentData, ...data}});
        console.log(this.state.search);
    }

    componentWillMount() {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user !== null
            //(user.role.indexOf('ROLE_SUPER_ADMIN') > -1 ||  user.role.indexOf('ROLE_SUPERVISOR')) > -1
        )
        {
            this.setState({auth: true, user: user});
            if (this.props.co.length === 0) {
                this.props.loadConclusions('',1)
            }
        }

    }

    componentWillReceiveProps(nextProps) {
        console.log('Props received');
        console.log(nextProps);
        this.setState(nextProps);
    }

    updateInput = input => {
        this.setState({ search: {[input.name]: input.value}});
    };
    handleSearch = (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        this.props.loadConclusions('', 1, data);
    }

    render () {
        if (this.state.auth == false) {
            return (<Redirect to="/login"/>)
        }
        const { user } = this.state;
        const {classes, co} = this.props;

        let cos = Array.isArray(co)? (<Paper>
            {co.map(item => (
                <Grid container spacing={10}>
                    <Grid item xs={1}>{item.expertize_number}</Grid>
                    <Grid item xs={2}>{item.name}</Grid>
                    <Grid item xs={1}>{item.region}</Grid>
                    <Grid item xs={2}>{item.designer}</Grid>
                    <Grid item xs={2}>{item.customer}</Grid>
                    <Grid item xs={1}><a target='blank' href={`/conclusions/${item.path}`}>{item.reg_number}</a></Grid>
                    <Grid item xs={2}>{item.realization_date}</Grid>
                    <Grid item xs={1}>{item.funds}</Grid>
                </Grid>
           ))}
        </Paper>) : (<Paper></Paper>)
        return (
            <div>
                {(this.state.user.role.indexOf('ROLE_SUPERVISOR')>=0) && (<Header link={{to:'/supervision/', title: this.state.user.org}} />)}
                {(user.role.indexOf(roles.ROLE_INSPECTOR_APPEALS) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_MAIN) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_MANAGER) >= 0) && (<Header link={{to:'/inspection/', title: this.state.user.org}} />)}

                {(this.state.user.role.indexOf('ROLE_SUPER_ADMIN')>=0) && (<Header link={{to:'/admin/', title: this.state.user.org}} />)}
                <Toolbar>
                    {((this.state.user.role.indexOf('ROLE_SUPERVISOR')>=0)) &&(<Button component={Link} to="/supervision">Вернуться</Button>)}
                    {(user.role.indexOf(roles.ROLE_INSPECTOR_APPEALS) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_MAIN) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_RECEIVE) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_REPLIES) >= 0 || user.role.indexOf(roles.ROLE_INSPECTOR_MANAGER) >= 0)  &&(<Button component={Link} to="/inspection">Вернуться</Button>)}
                    {((this.state.user.role.indexOf('ROLE_SUPER_ADMIN')>=0)) &&(<Button component={Link} to="/admin">Вернуться</Button>)}

                    <Button onClick={this.logout}>Выйти</Button>
                </Toolbar>
                <div className={classes.contentWrapper}>
                    <div className={classes.root}>
                        <OldBrowserMessage />
                        <Grid container spacing={10}>
                            <Grid item xs={1}>Экспертный орган</Grid>
                            <Grid item xs={2}>Название</Grid>
                            <Grid item xs={1}>Регион</Grid>
                            <Grid item xs={2}>Проектировщик</Grid>
                            <Grid item xs={2}>Заказчик</Grid>
                            <Grid item xs={1}>Зкспертиза</Grid>
                            <Grid item xs={2}>Дата</Grid>
                            <Grid item xs={1}>Бюджет</Grid>
                        </Grid>
                        <form onSubmit={this.handleSearch} ref={this.searchCo} id="search_co">
                        <Grid container spacing={10}>
                            <Grid item xs={1}><input name="expertize_number"/></Grid>
                            <Grid item xs={2}><input style={{width:'100%'}}name="name"/></Grid>
                            <Grid item xs={1}><input name="region"/></Grid>
                            <Grid item xs={2}><input style={{width:'100%'}} name="designer"/></Grid>
                            <Grid item xs={2}><input style={{width:'100%'}} name="customer"/></Grid>
                            <Grid item xs={1}><input style={{width:'7em'}}name="reg_number"/></Grid>
                            <Grid item xs={2}>
                                <DatePicker
                                    name="realization_date_from"
                                    keyboard
                                    clearable
                                    label="от"
                                    value={this.state.search.realization_date_from}
                                    onChange={this.updateDateInput('realization_date_from')}
                                    format='YYYY-MM-DD'
                                    animateYearScrolling={false}
                                    //minDate={new Date()}
                                    //onInputChange={e => console.log("Keyboard Input:", e.target.value)}
                                />
                                <DatePicker
                                    keyboard
                                    clearable
                                    name="realization_date_to"
                                    label="до"
                                    value={this.state.search.realization_date_to}
                                    onChange={this.updateDateInput('realization_date_to')}
                                    animateYearScrolling={false}
                                    format='YYYY-MM-DD'
                                    //minDate={new Date()}
                                    //onInputChange={e => console.log("Keyboard Input:", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={1}><button type="submit">поиск</button></Grid>
                        </Grid>
                        </form>
                        { cos }
                        <Pager token=''
                               search={new FormData(document.forms[0])}
                               page={this.props.page}
                               total={this.props.total}
                               handle={this.props.loadConclusions}
                        />
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

ObjectsInspector.defaultProps = {
    page: 1,
    bo: []
}
function mapDispatch(dispatch) {
    return {
        loadConclusions: bindActionCreators(loadConclusions, dispatch),
        logout: bindActionCreators(logout, dispatch),
        clearRedirect: bindActionCreators(clearRedirect, dispatch)
    };
}


function select(state, props) {
    const { co } = state;
    console.log('SELECT');
    console.log(co);

    return {
        co: co.co || [],
        page: co.page || 1,
        total: co.total || 50
    };
}

// Objects.propTypes = {
//     classes: PropTypes.object.isRequired,
// };

export const ObjectsInspectorWithStyles = withStyles(styles)(ObjectsInspector);

export default connect(select, mapDispatch)(ObjectsInspectorWithStyles);



// WEBPACK FOOTER //
// ./assets/src/js/components/pages/Conclusions.jsx